import { Component } from '@angular/core';

import { WindowService } from '@public/core';

import { ContentComponent, FooterComponent, HeaderComponent, LayoutComponent } from '@public/core/ui/layout';

import { FooterContentComponent, HeaderContentComponent } from '@naturfond/common';

@Component({
  templateUrl: './terms-of-use.component.html',
  styleUrls: ['./terms-of-use.component.scss'],
  imports: [
    ContentComponent,
    FooterComponent,
    HeaderComponent,
    LayoutComponent,

    FooterContentComponent,
    HeaderContentComponent,
  ],
})
export class TermsOfUseComponent {
  constructor(public windowService: WindowService) {}
}
